import theme from 'ui/theme';
import { shadeColor } from 'utils/common';

export const graphPalette = () => {
  const choosedColor = theme().colors.mainBlue;

  return {
    shade1: shadeColor(choosedColor.toString(), 60),
    shade2: shadeColor(choosedColor.toString(), 50),
    shade3: shadeColor(choosedColor.toString(), 40),
    shade4: shadeColor(choosedColor.toString(), 30),
    shade5: shadeColor(choosedColor.toString(), 20)
  };
};

const chargersStatus = {
  chargingStatusNumber: {
    label: 'Charging',
    labelColor: '#ffffff',
    primary: '#467afb' //graphPalette().shade1
  },
  availableStautusNumber: {
    label: 'Available',
    labelColor: '#ffffff',
    primary: '#00ad3e' //graphPalette().shade2
  },
  disconnectedStatusnumber: {
    label: 'disconnected',
    labelColor: '#ffffff',
    primary: '#c5c5c5' //graphPalette().shade3
  },
  waiting: {
    label: 'Waiting',
    labelColor: '#ffffff',
    primary: '#a358f8' //graphPalette().shade4
  },
  faultStatusNumber: {
    label: 'faulted',
    labelColor: '#ffffff',
    primary: '#f29339' //graphPalette().shade5
  }
};

const chargerStatus = {
  availableStatusNumber: {
    label: 'Available',
    labelColor: '#ffffff',
    primary: '#00ad3e'
  },
  faultStatusNumber: {
    label: 'Faulted',
    labelColor: '#ffffff',
    primary: '#f29339'
  },
  chargingStatusNumber: {
    label: 'Charging',
    labelColor: '#ffffff',
    primary: '#467afb'
  },
  disconnectedStatusNumber: {
    label: 'Disconnected',
    labelColor: '#ffffff',
    primary: '#ececed'
  },
  preparingStatusNumber: {
    label: 'Preparing',
    labelColor: '#7ad199',
    primary: '#c5c5c5'
  },
  finishingStatusNumber: {
    label: 'Finishing',
    labelColor: '#ffffff',
    primary: '#89bbff'
  },
  unavailableStatusNumber: {
    label: 'Unavailable',
    labelColor: '#ffffff',
    primary: '#c5c5c5'
  },
  suspendedEVStatusNumber: {
    label: 'Suspended EV',
    labelColor: '#ffffff',
    primary: '#a358f8'
  },
  suspendedEVSEStatusNumber: {
    label: 'Suspended EVS',
    labelColor: '#ffffff',
    primary: '#f5cb00'
  }
};

const driversStatus = {
  enabled: {
    label: 'enabled',
    labelColor: '#ffffff',
    primary: theme().colors.bubble.one
  },
  disabled: {
    label: 'disabled',
    labelColor: '#ffffff',
    primary: theme().colors.bubble.three
  }
};
const campaignStatus = {
  activeNumber: {
    label: 'active',
    labelColor: '#ffffff',
    primary: theme().colors.blue.one
  },
  draftNumber: {
    label: 'draft',
    labelColor: '#ffffff',
    primary: theme().colors.lightGray4
  },
  stoppedNumber: {
    label: 'stopped',
    labelColor: '#ffffff',
    primary: theme().colors.lightOrange
  },
  endNumber: {
    label: 'ended',
    labelColor: '#ffffff',
    primary: theme().colors.violet
  }
};

export const getStateColor = status => chargersStatus[status] || {};

export const getDriversStatusColor = status => driversStatus[status] || {};

export const getChargerStatusColor = status => chargerStatus[status] || {};

export const getCampaignStatusColor = status => campaignStatus[status] || {};
